/**
 * Selectors for portaled descendants that Radix Dialog would otherwise treat
 * as outside-clicks. Documented stable forms only — never hashed class names,
 * which rotate on a dependency upgrade.
 */
const PORTALED_NON_DISMISS_SELECTORS =
  '.notistack-Snackbar, .notistack-SnackbarContainer, [data-radix-popper-content-wrapper]';

/**
 * Returns true when the pointer-down event originates inside a portaled UI
 * that should NOT dismiss the dialog (notistack toasts, Radix poppers —
 * Tessra dropdowns/popovers/tooltips/menus).
 */
export function isPortaledNonDismissTarget(target: EventTarget | null): boolean {
  return Boolean((target as Element | null)?.closest(PORTALED_NON_DISMISS_SELECTORS));
}
